<script>
    import {projectDetailStore} from "../../../../stores/projectStore";
    import {projectSaleStore} from "../../../../stores/saleStore";
    import {tokenDetailStore} from "../../../../stores/tokenStore";
    import ProgressBar from "../progress-bar/ProgressBar.svelte";


    let projectDetails, tokenDetails, saleDetails;
    let networks = {};

    projectDetailStore.subscribe(value => {
        projectDetails = value;
        for(let key in projectDetails.mediaUrls) {
            if (projectDetails.mediaUrls[key])
                networks[key] = projectDetails.mediaUrls[key];
        }
        networks = networks;
    });
    projectSaleStore.subscribe((value => {
        saleDetails = value;
    }));
    tokenDetailStore.subscribe((value => {
        tokenDetails = value;
    }));

    let poolSize = tokenDetails.projectTokenPrice * tokenDetails.initialSupply;
    let date = new Date(saleDetails.startDateAndTime)
    let startDate = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    let localImageFile = projectDetails.coverImage instanceof File
        ? URL.createObjectURL(projectDetails.coverImage)
        : projectDetails.coverImage.url


</script>
<div class="detail-preview-wrap">
    <div class="detail-main-title form-row items-center">
        <div class="col-7">
            {#if projectDetails }
                <h2>{projectDetails.projectTitle}</h2>
                <p>{projectDetails.shortDescription}</p>
            {/if}
        </div>
        <div class="col-5 flex flex-text-right">
            <span class="status">Draft</span>
        </div>
    </div>
    <div class="preview-details">
        <div class="form-row">
            <div class="col-7">
                <img class="preview-image" src={localImageFile ? localImageFile : "./images/detail-preview.jpg"} alt="preview image">
            </div>
            <div class="col-5">
                {#if tokenDetails }
                    <div class="flex pool-wrapper items-start">
                        <span class="sizes mr-auto">Pool Size <strong>${poolSize}</strong></span>
                        <span class="sizes ml-auto">Project Token <strong>{`${tokenDetails.tokenName}(${tokenDetails.tokenSymbol})`}</strong></span>
                    </div>
                    <ul class="list-token flex-wrap flex list-none">
                        <li><span>Price Per Token<strong>{`$ ${tokenDetails.projectTokenPrice}`}</strong></span></li>
                        <li><span>Total Available Tokens<strong>{tokenDetails.initialSupply}</strong></span></li>
                        <li><span>Individual purchase limit<strong>{saleDetails.capPerWallet} rTKN</strong></span></li>
                    </ul>
                {/if}
                {#if saleDetails}
                    <div class="flex flex-wrap items-center">
                        <span class="sizes mr-auto">Launch Date <strong>{startDate}</strong></span>
                        <span class="sizes ml-auto">Time Remaining <strong>3h 40min</strong></span>
                    </div>
                    <ProgressBar raiseTarget={tokenDetails.initialSupply} />
                {/if}
                <br>
                <a class="approved-btn flex flex-text-center">Approve</a>
            </div>
            <div class="col-12">
                {#if Object.entries(networks).length > 0}
                <div class="detail-social flex items-center"  >
                    <strong>Social Network:</strong>
                    {#each Object.entries(networks) as [key, url]}
                            <a href={url.includes('http') ? url : `https://${url}`} target="_blank" ><img src={`./images/ic_${key}.svg`}  alt={key}></a>
                    {/each}
                </div>
                {/if}
            </div>
        </div>
    </div>
</div>